export const initialState = {
  practiceId: '',
  departmentId: null,
};

export const AthenaDepartmentIdOptions = [
  { label: 'Neurology Danvers', value: 1 },
  { label: 'GUIDE', value: 2 },
  { label: 'Neurology Orange County', value: 4 },
  { label: 'Neurology Bay Area', value: 5 },
  { label: 'Test Department', value: 3 },
];
